"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const sizeof_1 = require("sizeof");
class Logger {
    constructor(url, info) {
        this.logs = [];
        this.loggerUrl = url;
        this.labels = info;
        this.start();
    }
    static ObjectSize(object) {
        try {
            return (0, sizeof_1.sizeof)(object);
        }
        catch (error) {
            return Logger.LOG_MAX_SIZE;
        }
    }
    start() {
        if (this.flushIntervalId != null) {
            this.stop();
        }
        this.flushIntervalId = setInterval(() => {
            this.flush();
        }, Logger.FLUSH_INTERVAL);
    }
    stop() {
        clearInterval(this.flushIntervalId);
    }
    setMerchantId(merchantId) {
        this.labels.merchantId = merchantId;
    }
    setDeviceId(deviceId) {
        this.labels.deviceId = deviceId;
    }
    setUserId(userId) {
        this.labels.userId = userId;
    }
    setEnv(environment) {
        this.labels.environment = environment;
    }
    handleFlushError(error, logs, methodName = 'flush') {
        const isNetworkError = (error.response === undefined) || error.code === 'ENOTFOUND';
        const dataSize = Logger.ObjectSize(logs);
        const errorType = isNetworkError ? 'network error' : 'server error';
        const message = `[Logger] ${methodName} ${logs.length} logs failed (${dataSize} bytes), ${errorType}: ${String(error)}`;
        // Re-queue failed logs to front and enforce limit in single operation
        this.logs = [...logs, ...this.logs].slice(0, Logger.LOG_MAX_LENGTH);
        // Log to console only (avoid infinite loop)
        console.error(message, error);
    }
    prepareLogs() {
        if (this.logs.length === 0)
            return null;
        const logs = lodash_1.default.clone(this.logs);
        this.logs = [];
        const logSize = Logger.ObjectSize(logs);
        if (logSize >= Logger.LOG_MAX_SIZE) {
            // 超過大小時，最後一筆放入 logs 下一次再送
            const lastLog = logs.pop();
            this.logs.push(lastLog);
        }
        return logs;
    }
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    sendLogs(logs) {
        return axios_1.default.post(this.loggerUrl, {
            logs,
            labels: lodash_1.default.chain(this.labels).omitBy(lodash_1.default.isNull).omitBy(lodash_1.default.isUndefined).value(),
        });
    }
    log(level, data, timestamp) {
        const newLog = {
            level,
            data,
            timestamp,
        };
        const stashLogSize = Logger.ObjectSize(this.logs); // 現存的 logs 大小
        let newLogSize = Logger.ObjectSize(newLog); // 新的 log 大小
        if (newLogSize > Logger.LOG_MAX_SIZE) {
            // 單一 log 大小已超過限制，將 newLog 改成只送出 message 並留下警告
            newLog.level = 'warn';
            newLog.data = { message: newLog.data.message, warning: `log size over limit ${Logger.LOG_MAX_SIZE} bytes, send message without other data`, size: newLogSize };
            newLogSize = Logger.ObjectSize(newLog); // 更新 size
        }
        // 加入 log
        this.logs.push(newLog);
        if (['error', 'warn'].includes(level) || // 遇到 error 或 warn  level 的 log 就優先送出
            this.logs.length >= Logger.LOG_MAX_LENGTH || // 加入新的 log 後長度達到限制，立即送出
            stashLogSize + newLogSize >= Logger.LOG_MAX_SIZE // 加入新 log 後大小達到上限，立即送出
        ) {
            this.flush();
        }
    }
    flush() {
        const logs = this.prepareLogs();
        if (logs === null)
            return;
        this.sendLogs(logs).catch((error) => {
            this.handleFlushError(error, logs, 'flush');
        });
    }
    asyncFlush() {
        return __awaiter(this, void 0, void 0, function* () {
            const logs = this.prepareLogs();
            const emptyResponse = {
                data: {},
                status: 200,
                statusText: 'OK',
                headers: {},
                config: {},
            };
            if (logs === null) {
                return yield Promise.resolve(emptyResponse);
            }
            return yield this.sendLogs(logs)
                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                this.handleFlushError(error, logs, 'asyncFlush');
                return yield Promise.resolve(emptyResponse);
            }));
        });
    }
}
exports.default = Logger;
Logger.LOG_MAX_LENGTH = 500;
Logger.LOG_MAX_SIZE = 256000;
Logger.FLUSH_INTERVAL = 5000;
//# sourceMappingURL=Logger.js.map